import { Button, ButtonSiteActivityPropsV2 } from 'components/Button/Button'
import { MySpinner } from 'components/MySpinner/MySpinner'

export interface UpdateAccountModalActionsProps {
  loading?: boolean,
  submitButtonText: string,
  submitSiteActivityProps: ButtonSiteActivityPropsV2
  cancelButtonText: string,
  handleCancel: () => void,
}

export const UpdateAccountModalActions: React.FC<UpdateAccountModalActionsProps> = ({
  loading,
  submitButtonText,
  submitSiteActivityProps,
  cancelButtonText,
  handleCancel
}) => {
  return (
    <div className="ds-c-dialog__actions">
      <div className="ds-l-form-row">
        <div className="ds-l-col--12 ds-l-sm-col--auto my-u-my--2">
          <Button
            type="submit"
            className="ds-c-button ds-c-button--solid my-u-py--6 my-u-width--full"
            siteActivityProps={submitSiteActivityProps}
          >
            {loading && (
              <MySpinner size='small' inverse isInButton/>
            )}
            {submitButtonText}
          </Button>
        </div>
        <div className="ds-l-col--12 ds-l-sm-col--auto my-u-my--2">
          <Button
            className="ds-c-button my-u-py--6 my-u-width--full"
            onClick={handleCancel}
          >
            {cancelButtonText}
          </Button>
        </div>
      </div>
    </div>
  )
}
